import { constants, mediaQueryStyles } from "@newsela/angelou";
const { breakpoints } = constants;
const { md } = breakpoints.BreakpointNames;
const { mediaQuery: breakpoint } = mediaQueryStyles;

const { ui } = constants.colors;

export const headerRowCss = {
  display: "flex",
  justifyContent: "space-between",
};

const ButtonCss = {
  paddingLeft: 0,
  fontSize: "12px !important",
};

export const featureButtonCss = {
  ...ButtonCss,
  padding: "8px",
};

export const reportButtonCss = {
  ...ButtonCss,
};

export const rowCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const baseButtonCss = {
  fontSize: "14px !important",
  fontWeight: "700",
  padding: "4px",
};
export const legacyAIButtonCss = {
  ...baseButtonCss,
  backgroundColor: `linear-gradient(279.44deg, #691C9C 4.6%, #1F3CD7 66.61%, #1088EB 100%) !important`,
  ":hover": {
    backgroundColor: ui.neutral[300],
  },
};

export const lunaAIButtonCss = (showLunaText: boolean) => ({
  padding: "0",
  display: "flex",
  backgroundColor: ui.white[700],
  borderRadius: showLunaText ? "4px" : "2px",
  height: showLunaText ? "auto" : "25px",
  border: `1px solid transparent`,
  ":hover": {
    backgroundColor: ui.neutral[25],
    filter: "grayscale(20%)",
    cursor: "pointer",
  },
  ":focus, :active": {
    backgroundColor: ui.neutral[25],
    filter: "grayscale(20%)",
    cursor: "pointer",
    borderColor: ui.core[700],
  },
});

export const tooltipCss = (
  showLunaAiBranding: boolean,
  showLunaText: boolean,
) => ({
  dialog: {
    ":before": {
      width: "14px",
    },
    root: {
      maxWidth: "300px",
      "div:last-of-type": {
        marginTop: "-0.5px",
      },
      zIndex: 2,
      // Because the ElaSkillsActivityPanel has a higher z-index on smaller screens, the dialog also needs a higher z-index on smaller screens
      [breakpoint.upTo(md)]: {
        zIndex: 12,
        "div:last-of-type": {
          marginTop: "1px",
        },
      },
    },
  },
  Button: {
    root: showLunaAiBranding
      ? lunaAIButtonCss(showLunaText)
      : legacyAIButtonCss,
  },
});
